import * as React from 'react'
import {
  StyleguideChaptersConfig,
  StyleguideCompanyInfoType,
  StyleguideCompanyType,
  StyleguideConfig,
  StyleguidePages,
  StyleguideProjectInfoType,
} from '../types'
import { styleguideGetCompanyInfo, styleguideGetProjectInfo } from '../utils/helpers'
import { StyleguideNavigation } from './renderers'

export const StyleguideHeader = (props: { currentPage: StyleguidePages; config: StyleguideConfig }) => {
  const { currentPage, config } = props
  return (
    <>
      <header className="styleguide__header">
        <StyleguideProjectInfo {...config.project} />

        <div className="styleguide-nav__wrapper styleguide--styled" data-active-page={currentPage}>
          <nav className="styleguide-nav">
            <h2 className="sr-text">Menu</h2>

            <ol className="styleguide-nav__list">
              <NavGroupItem chapter={config.chapters.tokens} breakpoint={config.breakpoint} currentPage={currentPage} />
              <NavGroupItem
                chapter={config.chapters.objects}
                breakpoint={config.breakpoint}
                currentPage={currentPage}
              />
              <NavGroupItem
                chapter={config.chapters.components}
                breakpoint={config.breakpoint}
                currentPage={currentPage}
              />
              <NavGroupItem
                chapter={config.chapters.compositions}
                breakpoint={config.breakpoint}
                currentPage={currentPage}
              />
            </ol>
          </nav>

          <StyleguideCompanyInfo {...config} />
        </div>
      </header>
    </>
  )
}
const NavGroupItem = (props: {
  chapter: StyleguideChaptersConfig[]
  breakpoint: number
  currentPage: StyleguidePages
}) => {
  return (
    <>
      {props.chapter.length > 0 && (
        <li className="styleguide-nav__group">
          <ul className="styleguide-nav__grouplist">
            {props.chapter.map((chapter) => (
              <StyleguideNavigation
                key={`sg-chapter-${chapter.slug}`}
                currentPage={props.currentPage}
                chapterType={chapter.slug}
                config={chapter}
                breakpoint={props.breakpoint}
              />
            ))}
          </ul>
        </li>
      )}
    </>
  )
}

export const StyleguideProjectInfo = (project: StyleguideProjectInfoType) => {
  const styleguideProjectInfo: StyleguideProjectInfoType = styleguideGetProjectInfo(project)

  return (
    <div className="styleguide__brand">
      <a className="styleguide__logo-link" href="/styleguide">
        <h1 className="sr-text">Styleguide {styleguideProjectInfo.name}</h1>
        <img className="styleguide__logo" width="170" height="50" src={styleguideProjectInfo.logoSrc} alt="" />
      </a>

      <button
        className="styleguide-toggler"
        onClick={(e) => document.documentElement.classList.toggle('styleguide-nav--toggled')}
      >
        <span className="sr-text">Toggle Menu</span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>
    </div>
  )
}

export const StyleguideCompanyInfo = (props: { company: StyleguideCompanyType }) => {
  const styleguideCompanyInfo: StyleguideCompanyInfoType = styleguideGetCompanyInfo(props.company)

  return styleguideCompanyInfo !== null ? (
    <div className="styleguide__extra styleguide--styled">
      <a className="styleguide__extra-link" href={styleguideCompanyInfo.url}>
        <span className="sr-text">by {styleguideCompanyInfo.name}</span>
        <span className="styleguide__extra-suffix" aria-hidden="true">
          by
        </span>
        <img
          className="styleguide__extra-logo"
          width="200"
          height="100"
          src={`https://giustoragev2.blob.core.windows.net/shoppinger/logo-${props.company}.svg`}
          alt=""
        />
      </a>
    </div>
  ) : (
    <></>
  )
}
